<template>
  <div class="container">
    <SucceedFour :tracker="callTracker" v-if="template == 4" />
    <SucceedThree :tracker="callTracker" v-else-if="template == 3" />
    <SucceedTwo :tracker="callTracker" v-else-if="template == 2" />
    <SucceedOne :tracker="callTracker" v-else />
  </div>
</template>

<script>
import { isEmpty } from "lodash/fp";
import SucceedOne from "./components/SucceedOne.vue";
import SucceedTwo from "./components/SucceedTwo.vue";
import SucceedThree from "./components/SucceedThree.vue";
import SucceedFour from "./components/SucceedFour.vue";
import { formatterPoint } from "../../utils/tools";
import { trackerConfig } from "../../utils/bigDataSdk";

export default {
  components: {
    SucceedOne,
    SucceedTwo,
    SucceedThree,
    SucceedFour,
  },
  data() {
    return {
      template: 1,
    };
  },

  mounted() {
    const query = this.$route.query || {};
    // 获取url参数
    const {
      longitude,
      latitude,
      token,
      phone,
      unionid: unionId,
      network_id: netWorkId,
      guide_id: guideId,
      guide_name: guideName,
      activity_id: activityId,
      activity_code: activityCode,
      activity_name: activityName,
      resource_id: resourceId,
      resource_name: resourceName,
      address,
      link_id: linkId,
    } = query;

    this.tracker = trackerConfig({
      pageGuideId: guideId,
      pageGuideName: guideName,
      activityId,
      activityName,
      resourceId,
      resourceName,
    });
    this.template = query.template || 1;
    if (isEmpty(this.$store.state.activity.adviser)) {
      const base = {
        point: formatterPoint(longitude, latitude),
        unionId,
        guideId,
        netWorkId,
        linkId,
      };
      this.$store.dispatch({
        type: "getRecommendUserInfo",
        meta: {
          ...base,
          token,
        },
      });
      this.$store.dispatch({
        type: "getActivityApplyConfig",
        meta: {
          ...base,
          phone,
          activityId: activityId,
          activityCode,
          originalAddress: address,
        },
      });
    }
  },

  methods: {
    callTracker(meta) {
      this.tracker(meta);
    },
  },
};
</script>

<style lang="scss" scoped></style>
